/*
 * @Author: yinheng_1108 heng.yin@definsys.com
 * @Description: 
 */
export default {
    user: {
        baseInfo: '基本信息',
        roleAdd: '角色添加',
        roleEdit: "角色编辑",
        roleDetail: "角色详情",
        loginAccount: '登录名',
        Role: '角色',
        accountPlaceholder: "请输入登录名",
        password: '登录密码',
        passwordPlaceholder: '请输入登录密码',
        roleType: '角色类型',
        roleTypePlaceholder: "请选择角色类型",
        managerName: "管理员姓名",
        managerNamePlaceholder: "请输入管理员姓名",
        overview: '概述',
        overviewPlaceholder: '请输入概述',
        accountRequired: "请输入登录号",
        pwdRequired: "请输入登录密码",
        roleTypeRequired: "请选择角色类型",
        managerRequired: "请输入管理员姓名",
        overviewRequired: "请输入概述",
        charLength1_99: '长度在 1 到 99 个字符',
        charLength2_5: "长度在 2 到 5 个字符",
        charLength2_20: "长度在 2 到 20 个字符",
        editSuccess: "编辑成功",
        InfoRequired: "信息尚未填写完整",

        stop: "停用",
        multiplexing: "复用",
        recovery: "恢复",
        warning: '温馨提示',
        warningText: '当前操作会影响该角色正常使用，请确认是否改变',
        operateSuccess: "操作成功"
    },
    jurisdiction: {
        role: '角色',
        warningText: "当前角色操作尚未保存，是否保存",
        jurisdiction: '权限',
        roleNameRequired: "角色名字不能为空",
        jurisdictionRequired: "请至少选择一个权限",
    }

}


// WEBPACK FOOTER //
// ./src/views/install/install.zh-CN.js